import request from './request'

export function listShiftOutput(data) {
  return request.post('/production/shift-outputs/list', data || {})
}
